import { render, staticRenderFns } from "./PatientRecordManagement.vue?vue&type=template&id=5a41f7db&scoped=true"
import script from "./PatientRecordManagement.vue?vue&type=script&lang=js"
export * from "./PatientRecordManagement.vue?vue&type=script&lang=js"
import style0 from "./PatientRecordManagement.vue?vue&type=style&index=0&id=5a41f7db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a41f7db",
  null
  
)

export default component.exports